import React from 'react';
import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';

export const LanguageToggle = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language.startsWith('it') ? 'en' : 'it';
    i18n.changeLanguage(newLang);
    
    // Force refresh components that might not update with language change
    const event = new Event('languageChanged');
    window.dispatchEvent(event);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="fixed top-20 right-4 p-3 rounded-full bg-white border border-slate-200 shadow-md hover:border-slate-400 transition-all duration-300 group z-50"
      aria-label="Toggle Language"
    >
      <Languages className="w-6 h-6 text-slate-700 group-hover:text-slate-900 transition-colors" />
      <span className="absolute right-full mr-2 top-1/2 -translate-y-1/2 bg-white px-2 py-1 rounded border border-slate-200 shadow-sm text-sm text-slate-700 opacity-0 group-hover:opacity-100 transition-opacity">
        {i18n.language.startsWith('it') ? 'English' : 'Italiano'}
      </span>
    </button>
  );
};